import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import Choices from './Choices';
import UserList from './UserList';
import UserListHeader from './UserListHeader';
import ImmutablePropTypes from 'react-immutable-proptypes';
import $ from 'jquery';
import {
  profileChanged,
  departmentChanged,
  regionChanged,
  tagsChanged,
  onUserSelected,
  onSelectAll,
  onUnselectAll,
  initUserList,
  fetchTagsIfNeeded,
  resetState,
} from '../actions/diffusion';
import {
  getTagsChoices,
  getTags,
  getRegion,
  getDepartment,
  getProfile,
  getRegionsChoices,
  getDepartmentsChoices,
  getProfilesChoices,
  getUsersChoices,
  getSelectedUsers,
  isFilterEmpty,
} from '../reducers/diffusion';

const mapStateToProps = state => ({
  tagsChoice: getTagsChoices(state),
  tags: getTags(state),
  regionsChoice: getRegionsChoices(),
  region: getRegion(state),
  departmentsChoice: getDepartmentsChoices(),
  department: getDepartment(state),
  profile: getProfile(state),
  profilesChoice: getProfilesChoices(state),
  usersChoice: getUsersChoices(state),
  selectedUsers: getSelectedUsers(state),
  isFilterEmpty: isFilterEmpty(state),
});

const mapDispatchToProps = dispatch => ({
  profileChanged: profile => dispatch(profileChanged(profile)),
  departmentChanged: department => dispatch(departmentChanged(department)),
  regionChanged: region => dispatch(regionChanged(region)),
  tagsChanged: tags => dispatch(tagsChanged(tags)),
  onUserSelected: user => dispatch(onUserSelected(user)),
  onSelectAll: () => dispatch(onSelectAll()),
  onUnselectAll: () => dispatch(onUnselectAll()),
  initUserList: () => dispatch(initUserList()),
  fetchTags: () => dispatch(fetchTagsIfNeeded()),
  resetState: () => dispatch(resetState()),
});

const onValidate = props => () => {
  const { validationCallback, resetState } = props;
  const datas = {
    selectedUsers: props.selectedUsers,
    profile: props.profile,
    region: props.region,
    department: props.department,
    tags: props.tags,
  };
  validationCallback(datas);
  resetState();
};

const onReset = props => () => {
  const { resetState, cancelCallback } = props;
  cancelCallback();
  resetState();
};

export class DiffusionModal extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    isOpened: PropTypes.bool,
    profilesChoice: PropTypes.array,
    tagsChoice: PropTypes.array,
    regionsChoice: PropTypes.array,
    departmentsChoice: PropTypes.array,
    usersChoice: ImmutablePropTypes.map,
    profileChanged: PropTypes.func,
    regionChanged: PropTypes.func,
    departmentChanged: PropTypes.func,
    tagsChanged: PropTypes.func,
    selectedUsers: ImmutablePropTypes.map.isRequired,
    onUserSelected: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onUnselectAll: PropTypes.func.isRequired,
    initUserList: PropTypes.func.isRequired,
    fetchTags: PropTypes.func.isRequired,
    validationCallback: PropTypes.func,
    cancelCallback: PropTypes.func,
    resetState: PropTypes.func.isRequired,
    selectable: PropTypes.bool.isRequired,
    isFilterEmpty: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
    this.onSelection = this.onSelection.bind(this);
    this.isSaveUnlocked = this.isSaveUnlocked.bind(this);
  }

  componentWillMount() {
    this.props.initUserList();
    this.props.fetchTags();
  }

  onSelection(selection) {
    if (this.props.selectable) {
      this.props.onUserSelected(selection);
    }
  }

  isSaveUnlocked() {
    if (this.props.selectable) {
      return this.props.selectedUsers.size > 0;
    } else {
      return !this.props.isFilterEmpty;
    }
  }

  render() {
    const {
      name,
      title,
      isOpened,
      profilesChoice,
      tagsChoice,
      regionsChoice,
      departmentsChoice,
      profileChanged,
      regionChanged,
      departmentChanged,
      tagsChanged,
      usersChoice,
      selectedUsers,
      onSelectAll,
      onUnselectAll,
      selectable,
    } = this.props;

    const tagsItems = tagsChoice.map(t => {
      t.key = t.name;
      return t;
    });

    const listHeight = $(window).height() - 580 + 'px';

    return (
      <div className="ui card">
        <Modal isOpened={isOpened} className={name} height="40px">
          <div className="header">{title}</div>
          <div className="content ui form">
            <div className="ui segment">
              <div className="ui three fields">
                <Choices
                  name="profile"
                  placeholder="Profil utilisateur"
                  label="Profil"
                  items={profilesChoice}
                  onChange={profileChanged}
                  singleChoice
                />
                <Choices
                  name="region"
                  placeholder="Région"
                  label="Régions"
                  items={regionsChoice}
                  onChange={regionChanged}
                  singleChoice
                />
                <Choices
                  name="deparment"
                  placeholder="Département"
                  label="Département"
                  items={departmentsChoice}
                  onChange={departmentChanged}
                  singleChoice
                />
              </div>
              <Choices
                name="tags"
                placeholder="Tags"
                label="Tags"
                items={tagsItems}
                onChange={tagsChanged}
                singleChoice={false}
              />
            </div>
            <UserListHeader
              selectedUsers={selectedUsers}
              usersChoice={usersChoice}
              selectable={selectable}
              onSelectAll={onSelectAll}
              onUnselectAll={onUnselectAll}
            />
            <div
              className="ui segment scrollContent"
              style={{ height: listHeight, overflowY: 'auto' }}
            >
              <UserList
                key="userlist"
                name="userList"
                users={usersChoice}
                onSelected={this.onSelection}
                selectedUsers={selectedUsers}
              />
            </div>
            <div className="ui segment right aligned">
              <div className="actions">
                <button
                  className="ui compact labeled icon button"
                  onClick={onReset(this.props)}
                >
                  <i className="close icon" />
                  Annuler
                </button>
                <button
                  className="ui compact labeled icon button"
                  onClick={onValidate(this.props)}
                  disabled={!this.isSaveUnlocked()}
                >
                  <i className="check icon" />
                  Valider
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DiffusionModal);



// WEBPACK FOOTER //
// ./src/modules/diffusion/components/DiffusionModal.js